import { useController } from 'react-hook-form'

import type { TrackFn } from '@flows/configs/analytics/blurTracking'
import { runOnBlurHook } from '@flows/configs/analytics/blurTracking'

export const useFormElementField = (props: {
  name: string
  onBlur?: Parameters<typeof runOnBlurHook>[0]['onBlur']
  track?: TrackFn
}) => {
  const { field, fieldState, formState } = useController({
    name: props.name,
  })
  const visibleError =
    fieldState.isTouched || formState.isSubmitted ? fieldState.error?.message : undefined

  const onBlur = () => {
    field.onBlur()
    runOnBlurHook({ onBlur: props.onBlur, value: field.value, track: props.track })
  }

  return { field, visibleError, onBlur }
}
